export default __webpack_public_path__ + "static/Canes-25ddcdb9265d713cf27c9f1f838acebf.mp4";